module.exports = __webpack_public_path__ + "img/Fb.cc2bd122.png";